import { languages } from './consts'
import type { AITranslationLanguageType } from './types'

export const isSupportedLanguage = (
  code: string,
): code is AITranslationLanguageType => {
  return languages.some((language) => language.code === code)
}
